module.exports = __webpack_public_path__ + "static/media/Quicksand.006ad8c5.woff2";